import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/ap-logo.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-48d56102")

_pushScopeId("data-v-48d56102")
const _hoisted_1 = { class: "login" }
const _hoisted_2 = { class: "pane" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  style: {"max-width":"400px"},
  alt: "AccidentPlan Logo"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("h3", null, "Account Terminated", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", null, "Sorry, but it looks like your account has been terminated.", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Log Out")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _createVNode(_component_el_button, {
        style: {"width":"100%"},
        type: "danger",
        onClick: _ctx.logout
      }, {
        default: _withId(() => [
          _hoisted_7
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
})